import { Reducer } from 'redux';
import {
  DELETE_ITEM,
  GET_ITEM,
  GET_ITEM_LIST,
  ItemActionTypes,
  ItemState,
  POST_ITEM,
  PUT_ITEM,
  UPDATE_ITEM_FILTERS
} from '../types/item.types';

const initialState: ItemState = {
  items: [],
  selectedItem: null,
  postSuccess: null,
  lastFetch: null,
  totalElements: 0,
  totalPages: 1,
  filters: null
};

export const itemReducer: Reducer<ItemState> = (
  state: ItemState = initialState, action
) => {
  const timeOfAction = new Date().getTime();

  switch ((action as ItemActionTypes).type) {
    case GET_ITEM_LIST:
      return {
        ...state,
        items: action.payload.page.content,
        selectedItem: null,
        postSuccess: null,
        lastFetch: timeOfAction,
        totalElements: action.payload.page.totalElements,
        totalPages: action.payload.page.totalPages
      };
    case GET_ITEM:
      return {
        ...state,
        postSuccess: null,
        selectedItem: action.payload.selectedItem,
        lastFetch: timeOfAction
      };
    case POST_ITEM:
      return {
        ...state,
        postSuccess: true,
        selectedItem: action.payload.newItem,
        lastFetch: timeOfAction
      };
    case PUT_ITEM:
      return {
        ...state,
        selectedItem: action.payload.selectedItem,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_ITEM:
      return {
        ...state,
        selectedItem: null,
        lastFetch: timeOfAction
      };
    case UPDATE_ITEM_FILTERS:
      return {
        ...state,
        filters: action.payload.filters
      };
    case 'GET_ALL_ITEMS':
      return {
        ...state,
        items: action.payload.items
      };

    default:
      return state;
  }
};
